import React, { useEffect } from "react";

import Aos from "aos";
import "aos/dist/aos.css";

import Menu from "../../Components/Menu";

import Section1_Header from "../S1_Header";
import Section2_About from "../S2_About";
import S6_Tokenomics from "../S4_Tokenomics";
import S7_Roadmap from "../S5_Contact";
import Section9_Footer from "../S7_Footer";

import { PageWrapper } from "../../Styles/style";

import Videostars from "../../../assets/images/mainbg.png"
import styled from "@emotion/styled";

const VideoBG = styled.img`
object-fit: cover;
position: fixed;
width: 100%;
height: 100VH;
`
const Wrapper = styled.div`
position: RELATIVE;
`
const MainPage = (props) => {
  useEffect(() => {
    Aos.init({ duration: 2000 });
    window.addEventListener("load", function () {
      Aos.init();
    });
  }, []);
  return (
    <>

      <PageWrapper style={{overflow:"hidden"}}>
        <VideoBG   src={Videostars}/>
        <Wrapper>
          <Menu/>
          <Section1_Header />
          <Section2_About />
          <S6_Tokenomics />
          <S7_Roadmap />
          <Section9_Footer />
        </Wrapper>
      </PageWrapper>
    </>
  );
};

export default MainPage;
